import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import TapSelect from '../../components/ui/TapSelect';
import { IAM_API_BASE_URL_2 } from '../../services/TapApiUrls';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../services/HttpAPICall';
import { toast } from 'react-toastify';
import InputCustomerSearch from '../includes/ui/InputCustomerSearch';
import InputVendorSearch from '../includes/ui/InputVendorSearch';

const CommonOwnerShipCategorySearch = forwardRef((props, ref) => {

    const access_token = useSelector(state => state.auth.access_token);
    const [assetSearchForm, setAssetSearchForm] = useState({
        search_ownership_category: props.value?.search_ownership_category || "",
        search_owner_ids: props.value?.search_owner_ids || [],
        search_owner_company: props.value?.search_owner_company || ''
    })
    const [searchedCustomer, setSearchedCustomer] = useState([])
    const [searchedVendor, setSearchedVendor] = useState([])
    const [allOwnerCategoryList, setAllOwnerCategoryList] = useState([])
    const [allOwnersList, setAllOwnersList] = useState([])

    useEffect(() => {
        addAssetFormData()
    }, [])

    useEffect(() => {
        if (props.onChange) {
            props.onChange(assetSearchForm);
        }
    }, [assetSearchForm]);
    useEffect(() => {
        if (props.onDataLoad) {
            props.onDataLoad({
                allOwnerCategoryList,
                allOwnersList,
                searchedCustomer,
                searchedVendor

            });
        }
    }, [allOwnerCategoryList, allOwnersList, searchedCustomer, searchedVendor]);
    const resetFormData = () => {
        setAssetSearchForm({
            search_ownership_category: "",
            search_owner_ids: [],
            search_owner_company: ''
        });
        setSearchedCustomer([]);
        setSearchedVendor([]);
    };
    useImperativeHandle(ref, () => ({
        reset: () => {
            resetFormData()
        }
    }));

    const addAssetFormData = () => {
        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/asset_add_form_data', access_token, {}, {}, (response) => {
            let respData = response.data;
            setAllOwnerCategoryList(respData && respData.ownership_category && respData.ownership_category.length > 0 ? respData.ownership_category.map(oc => { return ({ value: oc.key, label: oc.name }) }) : [])
            setAllOwnersList(respData && respData.owners && respData.owners.length > 0 ? respData.owners.map(oc => { return ({ value: oc.id, label: oc.name, search_owner_company: oc.owner_company }) }) : [])

        }, (error) => {
            toast.error(error?.msg, { position: toast.POSITION.TOP_RIGHT });
        })
    }

    const tapSelectChange = (selectedOption, fieldName) => {
        let value;
        if (Array.isArray(selectedOption)) {
            value = selectedOption.map(option => option.value);
        } else {
            value = selectedOption ? selectedOption.value : '';
        }


        setAssetSearchForm(prev => ({
            ...prev,
            [fieldName]: value
        }));

        if (fieldName === 'search_owner_ids' && selectedOption) {
            let ownerCompanies = [];
            if (Array.isArray(selectedOption)) {
                selectedOption.forEach(option => {
                    const selectedOwner = allOwnersList.find(owner => owner.value === option.value);
                    if (selectedOwner && selectedOwner.search_owner_company) {
                        ownerCompanies.push(selectedOwner.search_owner_company);
                    }
                });
            } else {
                const selectedOwner = allOwnersList.find(owner => owner.value === selectedOption.value);
                if (selectedOwner && selectedOwner.search_owner_company) {
                    ownerCompanies.push(selectedOwner.search_owner_company);
                }
            }

            setAssetSearchForm(prev => ({
                ...prev,
                search_owner_company: ownerCompanies.join(', ')
            }));
        }
    };

    const handleCustomerChange = (selectedOption) => {
        tapSelectChange(selectedOption, 'search_owner_ids');
        setSearchedCustomer(selectedOption);
        setAssetSearchForm(prev => ({
            ...prev,
            search_owner_company: ""
        }));
    };

    const handleVendorChange = (selectedOption) => {
        tapSelectChange(selectedOption, 'search_owner_ids');
        setSearchedVendor(selectedOption);
        setAssetSearchForm(prev => ({
            ...prev,
            search_owner_company: ""
        }));
    };

    const handleOwnerCategoryChange = (selectedOption) => {
        tapSelectChange(selectedOption, 'search_ownership_category');
        setAssetSearchForm(prev => ({
            ...prev,
            search_owner_ids: [],
            search_owner_company: ''
        }));
        setSearchedCustomer(null);
        setSearchedVendor(null);
    };

    const filterSelectedOwners = () => {
        if (!assetSearchForm.search_owner_ids || !Array.isArray(assetSearchForm.search_owner_ids)) {
            return [];
        }
        return allOwnersList.filter(s => assetSearchForm.search_owner_ids.includes(s.value));
    };
    return <>
        <div className="row mb-3 align-items-center">
            <label className={`col-form-label col-form-label-sm text-end  ${props?.categoryWidth ? "col-sm-2" : "col-sm-3"}`}>
                OwnerShip Category
            </label>
            <div className={props?.categoryWidth ? "col-sm-10" : "col-sm-6"}>
                <TapSelect
                    changeEvent={handleOwnerCategoryChange}
                    options={allOwnerCategoryList}
                    isSearchable={true}
                    isClearable={true}
                    value={allOwnerCategoryList.find(m => m.value === assetSearchForm.search_ownership_category)}
                    placeholder="Select Ownership Category"
                    containerHeight={props?.categoryWidth ? "30px" :""}
                    fontSize={props?.categoryWidth ? "93%" :""}
                />
            </div>
        </div>
        {assetSearchForm.search_ownership_category === "owned" ? (
            <>
                <div className='row mb-3'>

                    <label htmlFor="site_id" className={`col-form-label col-form-label-sm text-end  ${props?.categoryWidth ? "col-sm-2" : "col-sm-3"}`} >Asset Owner</label><br />
                    <div className={props?.categoryWidth ? "col-sm-10" : "col-sm-6"}>
                        <TapSelect
                            changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'search_owner_ids')}
                            options={allOwnersList}
                            isSearchable={true}
                            isClearable={true}
                            value={filterSelectedOwners()}
                            placeholder="Select Owner"
                            isMulti={true}
                            containerHeight={props?.categoryWidth ? "30px" :""}
                            fontSize={props?.categoryWidth ? "93%" :""}

                        />
                    </div>
                </div>
            </>
        ) : assetSearchForm.search_ownership_category === "customer" ? (
            <>
                <div className='row mb-3'>

                    <label htmlFor="site_id" className={`col-form-label col-form-label-sm text-end  ${props?.categoryWidth ? "col-sm-2" : "col-sm-3"}`}>Asset Customer</label><br />
                    <div className={props?.categoryWidth ? "col-sm-10" : "col-sm-6"}>
                        <InputCustomerSearch
                            changeEvent={handleCustomerChange}
                            value={searchedCustomer && Array.isArray(searchedCustomer) && searchedCustomer.length > 0 ? searchedCustomer.map(a => { a.label = a.display_label; return a; }) : []}
                            isMulti={true}
                            containerHeight={props?.categoryWidth ? "30px" :""}
                            fontSize={props?.categoryWidth ? "93%" :""}

                        />
                    </div>
                </div>
            </>
        ) : assetSearchForm.search_ownership_category === "vendor" ? (
            <>
                <div className='row mb-3'>

                    <label htmlFor="site_id" className={`col-form-label col-form-label-sm text-end  ${props?.categoryWidth ? "col-sm-2" : "col-sm-3"}`}>Asset Vendor</label><br />
                    <div className={props?.categoryWidth ? "col-sm-10" : "col-sm-6"}>
                        <InputVendorSearch
                            changeEvent={handleVendorChange}
                            value={searchedVendor && Array.isArray(searchedVendor) && searchedVendor.length > 0 ? searchedVendor.map(a => { a.label = a.display_label; return a; }) : []}
                            isMulti={true}
                            containerHeight={props?.categoryWidth ? "30px" :""}
                            fontSize={props?.categoryWidth ? "93%" :""}

                        />
                    </div>
                </div>
            </>
        ) : (
            <>
                <div className='row mb-3'>

                    <label htmlFor="site_id" className={`col-form-label col-form-label-sm text-end  ${props?.categoryWidth ? "col-sm-2" : "col-sm-3"}`}>Asset Owner</label><br />
                    <div className={props?.categoryWidth ? "col-sm-10" : "col-sm-6"}>
                        <TapSelect
                            changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'search_owner_ids')}
                            options={allOwnersList}
                            isSearchable={true}
                            isClearable={true}
                            value={allOwnersList.find(m => m.value === assetSearchForm.search_owner_ids)}
                            placeholder="Select Owner"
                            containerHeight={props?.categoryWidth ? "30px" :""}
                            fontSize={props?.categoryWidth ? "93%" :""}

                        />
                    </div>
                </div >

            </>
        )}
    </>
});

export default CommonOwnerShipCategorySearch;